import request from "@/utils/request";

/*=========================== 教研驾驶舱（区域教科研数据中枢）===========================*/
/* 说明：本文件为「教研驾驶舱」页面新增接口，统一走 AreaCockpitController，未改动任何既有接口 */

// 面板1：区域教研总览
export const areaCockpitOverview = (query) => {
    return request({
        url: "/businessservice/areaCockpit/overview",
        method: "get",
        params: query
    })
}

// 面板4：一体化教研驾驶舱
export const areaCockpitEva = (data) => {
    return request({
        url: "/businessservice/areaCockpit/eva",
        method: "post",
        data: data
    })
}

// 面板5：教科研驾驶舱
export const areaCockpitResearch = (query) => {
    return request({
        url: "/businessservice/areaCockpit/research",
        method: "get",
        params: query
    })
}

// 面板2/3：名师/名校长工作室驾驶舱
export const areaCockpitStudio = (data) => {
    return request({
        url: "/businessservice/areaCockpit/studio",
        method: "post",
        data: data
    })
}

// 面板6：资源中心驾驶舱
export const areaCockpitResource = (query) => {
    return request({
        url: "/businessservice/areaCockpit/resource",
        method: "get",
        params: query
    })
}

// 面板6 新增：资源类型分布（按课程类型统计课程数量）
export const areaCockpitCourseTypeDist = (query) => {
    return request({
        url: "/businessservice/areaCockpit/resource/courseTypeDist",
        method: "get",
        params: query
    })
}

// 面板6 新增：校本课程资源分布（仅未公开校本课程，按可查看组织排名）
export const areaCockpitSchoolCourseOrgRank = (query) => {
    return request({
        url: "/businessservice/areaCockpit/resource/schoolCourseOrgRank",
        method: "get",
        params: query
    })
}

// 面板7：师资培训驾驶舱
export const areaCockpitTrain = (query) => {
    return request({
        url: "/businessservice/areaCockpit/train",
        method: "get",
        params: query
    })
}
